import { genericErrorSlice } from '../reducers/genericErrorSlice';
import { getStore } from '../store';

type genericErrorActionType = 'genericError/setGenericError';

export const genericErrorProvider = (): {
  setGenericError: (genericError: string) => { payload: string; type: genericErrorActionType };
} => {
  const { dispatch } = getStore();
  const { setGenericError } = genericErrorSlice.actions;
  return {
    setGenericError: (genericError: string): { payload: string; type: genericErrorActionType } =>
      dispatch(setGenericError(genericError)),
  };
};
